export default __webpack_public_path__ + "static/media/banner_mobile.e90498f5.jpg";